import { Textarea as MantineTextarea, TextareaProps } from '@mantine/core';

export type ITextareaProps = TextareaProps;

/** @registry Design-layer pass-through over Mantine Textarea; import this instead of @mantine/core Textarea outside src/design. Extend here when Textarea needs house behavior. */
export const Textarea = MantineTextarea;
